import { Survey } from '../interfaces/survey.interface';
import { Workflow, WorkflowAssessmentResponse } from '../interfaces/workflow.interface';

/** Extracts an ID from a field that may be an object with an `id` property or already an ID. */
function extractId(field: unknown): number | null {
  if (field === null || field === undefined) return null;
  if (typeof field === 'object' && 'id' in field) {
    return (field as { id: number }).id;
  }
  return field as number;
}

/** True when a survey references the same site and application as the workflow. */
export function surveyMatchesWorkflow(survey: Survey, workflow: Workflow): boolean {
  return (survey.site ?? null) === extractId(workflow.site)
    && (survey.application ?? null) === extractId(workflow.application);
}

/** Converts a WorkflowAssessmentResponse to a Workflow by extracting IDs from nested objects. */
export function toWorkflowForStore(response: WorkflowAssessmentResponse): Workflow {
  return {
    ...response,
    assessment: response.assessment?.id ?? null,
    assessmentSurvey: response.assessmentSurvey?.id ?? null,
    baseline: extractId(response.baseline),
    bpSurvey: extractId(response.bpSurvey),
    site: extractId(response.site),
    serviceProvider: extractId(response.serviceProvider),
    assessor: extractId(response.assessor),
    assignedAssessor: extractId(response.assignedAssessor),
  } as Workflow;
}
